import React from "react";
import { ButtonBrand } from "../Button";
import { Link } from "react-router-dom";

export const CompareButton = ({
  venues = [],
  selectedCompany =null,
  onClick,
  buttonText = "Compare venues",
  classes = "w-full mb-4",
  route = "/compare-venues",
}) => {
  const hasVenues = venues.length > 0;
  const destination = hasVenues
    ? `${route}?venues=${venues.map(v => v.id).join(",")}${selectedCompany ? '&company=' + selectedCompany : ''}`
    : "#";

  return (
    <Link to={destination}>
      <ButtonBrand
        disabled={!hasVenues}
        title={
          hasVenues
            ? "Compare selected Venues"
            : "Select one or more Venues to compare"
        }
        classes={classes}
        to={destination}
        //   onClick={onClick}
      >
        {buttonText}
      </ButtonBrand>
    </Link>
  );
};
